import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { buildCompactNavigation, defaultNavigation } from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {

        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                // ✅ ابني الـ compact navigation حسب صلاحيات التوكن الحالي
                const compactNavigation: FuseNavigationItem[] = buildCompactNavigation();

                const defaultNav = cloneDeep(defaultNavigation);

                // دمج الـ children من الـ default navigation
                compactNavigation.forEach((compactNavItem) => {

                    defaultNav.forEach((defaultNavItem) => {

                        if (defaultNavItem.id === compactNavItem.id) {

                            compactNavItem.children = cloneDeep(defaultNavItem.children);

                        }

                    });

                });

                // Return the response
                return [
                    200,
                    {
                        compact: cloneDeep(compactNavigation),
                        default: defaultNav,
                    },
                ];

            });
    }
}